import { render, staticRenderFns } from "./CarouselComponent.vue?vue&type=template&id=75872a6c&lang=true&"
import script from "./CarouselComponent.vue?vue&type=script&lang=js&"
export * from "./CarouselComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports